import Icon, { Icons } from '../../elements/Icon';

const AssetLoading = () => {
  return (
    <div className="p-6 flex justify-center items-center">
      <Icon
        name={Icons.SPINNER_GAP}
        className="animate animate-spin"
        size={32}
      />
    </div>
  );
};

export default AssetLoading;
